module.exports = __webpack_public_path__ + "img/1.1da8bdd8.png";